
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/[person]",
      function () {
        return require("private-next-pages/team/[person].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/[person]"])
      });
    }
  